// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Environment } from '@kameleoon/javascript-sdk';

import { QE_VERSION as version } from '../app/constants/app-version';

import { AppEnvironment } from './AppEnvironment';

export const environment = {
	appEnvironment: AppEnvironment.DEV,
	production: false,
	version: `${version} (ENV:DEV)`,
	apiEndpointOrigin: 'https://quoteengine-dev.embracepetinsurance.com/api',
	apiVersion: 'v1',
	akitaPersistKey: 'EpiQE3Session_dev',
	appInsights: {
		instrumentationKey: 'f65a6575-451f-4f01-8771-c8af8ea63dd7',
	},
	cdnUrl: 'https://epiassets.azureedge.net/assets',
	datadog: {
		applicationId: '',
		clientToken: '',
		env: '',
	},
	statsig: {
		clientKey: 'client-VA5YT1jAdVe3b1cK7Byp9zZaMOcU7vruc20MEB2WLC0',
		environment: 'development'
	},
	// eslint-disable-next-line
	USAAAuth: {
		// eslint-disable-next-line
		USAARedirect: 'https://myembrace-dev.embracepetinsurance.com/USAALogin',
		// clientID: 'P55o7CnZ7qQOTQKrCu7fIhI3C01h0dYk', //client id for USAA
		clientID: 'lbXebhYIR2850HKj7iVn3l4oSdxo1uo6', // client id for USAA_SPA
		domain: 'embracepetinsurance-dev.auth0.com',
		callbackURL: `${location.origin}/callback`,
		apiUrl: 'https://quote-dev.embrace.dev',
		connection: 'USAA',
	},
	allstateTagManagerURL:
		'https://assets.adobedtm.com/d5ff4550c9ef/7acc29ede8f0/launch-fa273009300b-development.min.js',
	kameleoonEnvironment: Environment.Development,
	sentryDsn: 'https://ba99f3c4b1138b7b5a13ca6936fca2eb@o4506718314299392.ingest.sentry.io/4506752560070656',
	recaptcha: {
		siteKey: '6Lek9Z0pAAAAAM2hZIwOIO16vjj67juA_zME5Fk6',
	},
	privacyPolicyUrl: 'https://dev.embracepetinsurance.com/privacy-policy',
	embracePolicyUrl: 'https://dev.embracepetinsurance.com/coverage/embrace-terms',
	smsTermsAndConditionsUrl: 'http://pub.e.embracepetinsurance.com/mobile-terms-and-conditions',
	myEmbraceUrl: 'https://myembrace-dev.embracepetinsurance.com/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
